<style lang="scss" src='./SetupCourse.scss' scoped></style>
<template src="./SetupCourse.html"></template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import { getCourseById, getSensors, getWeatherStations, getUsers, getUsersCustomer } from '@/api/index';

  import CourseInfo from '@/views/course/setup/info/CourseInfo.vue';
  import CourseSensors from '@/views/course/setup/sensors/CourseSensors.vue';
  import CourseUsers from '@/views/course/setup/users/CourseUsers.vue';
  import CourseStations from '@/views/course/setup/stations/CourseStations.vue';
  import CourseNotes from '@/views/course/setup/notes/CourseNotes.vue';
  
  import icCourseInfoActive from '@/assets/img/course/setup/ic_course_active.png';
  import icCourseSensorsActive from '@/assets/img/course/setup/ic_sensors_active.png';
  import icCourseSensorsInactive from '@/assets/img/course/setup/ic_sensors_inactive.png';
  import icCourseWeatherActive from '@/assets/img/course/setup/ic_weather_active.png';
  import icCourseWeatherInactive from '@/assets/img/course/setup/ic_weather_inactive.png';
  import icCourseUsersActive from '@/assets/img/course/setup/ic_users_active.png';
  import icCourseUsersInactive from '@/assets/img/course/setup/ic_users_inactive.png';
  import icCourseNotesActive from '@/assets/img/course/setup/ic_notes_active.png';
  import icCourseNotesInactive from '@/assets/img/course/setup/ic_notes_inactive.png';

  import i18n from './../../../i18n';

  const SetupComponents = [
    {
      step: 1,
      component: CourseInfo,
      title: i18n.t('facility.facilityInfo'),
      iconActive: icCourseInfoActive,
    },
    {
      step: 2,
      component: CourseSensors,
      title: i18n.t('sensors.sensors'),
      iconActive: icCourseSensorsActive,
      iconInactive: icCourseSensorsInactive,
    },
    {
      step: 3,
      component: CourseStations,
      title: i18n.t('weatherStation.stations'),
      iconActive: icCourseWeatherActive,
      iconInactive: icCourseWeatherInactive,
    },
    {
      step: 4,
      component: CourseUsers,
      title: i18n.t('users.users'),
      iconActive: icCourseUsersActive,
      iconInactive: icCourseUsersInactive,
    },
    {
      step: 5,
      component: CourseNotes,
      title: i18n.t('courses.agreementNote'),
      iconActive: icCourseNotesActive,
      iconInactive: icCourseNotesInactive,
    },
  ];

  export default {
    name: 'SetupCourse',
    components: {
      CourseInfo,
      CourseSensors,
      CourseUsers,
      CourseStations,
      CourseNotes,
    },

    data() {
      return {
        setupComponents: SetupComponents,
        courseId: null,
      };
    },

    computed: {
      ...mapState('CourseSetup', {
        step: (state) => state.step,
        loading: (state) => state.loading,
        canBack: (state) => state.canBack,
        canContinue: (state) => state.canContinue,
        showNewUserPage: (state) => state.showNewUserPage,
        showNewStationPage: (state) => state.showNewStationPage,
        course: (state) => state.setupData.course,
      }),
    },

    methods: {

      loadCourseInfo() {
        this.setLoading({course: true});
        getCourseById(this.courseId).then(course => {
          if (course && !this.G_isEmptyArr(course.background_images)) {
            course.background_images = course.background_images.map(i => ({...i, deleted: false}));
          }
          this.setSetupData({'course': course});
        }).finally(() => {
          this.setLoading({course: false});
        });
      },

      loadSensors() {
        this.setLoading({sensorsStored: true});
        getSensors(this.courseId).then((res) => {
          if (res && res.sensors) {
            const sensors = res.sensors.map((s) => ({...s, selected: false}));
            this.setSetupData({'sensors': sensors});
          }
        }).finally(() => {
          this.setLoading({sensorsStored: false});
        });
      },

      loadWeatherStations() {
        this.setLoading({stations: true});
        getWeatherStations(this.courseId).then((stations) => {
          if (stations) {
            this.setSetupData({'stations': stations});
          }
        }).finally(() => {
          this.setLoading({stations: false});
        });
      },

      loadUsers() {
        this.setLoading({users: true});
        getUsers(this.courseId).then((response) => {
          if (response && response.users) {
            this.setSetupData({'users': response.users});
          }
        }).finally(() => {
          this.setLoading({users: false});
        });
      },

      loadUsersCustomer() {
        this.setLoading({users: true});
        getUsersCustomer(this.courseId).then((response) => {
          if (response && response.users) {
            this.setSetupData({'users': response.users});
          }
        }).finally(() => {
          this.setLoading({users: false});
        });
      },

      async loadData() {
        if (this.courseId) {
          this.loadCourseInfo();
          this.loadSensors();
          this.loadWeatherStations();

          if (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS){
            this.loadUsers();
          } else {
            this.loadUsersCustomer();
          }

        }
      },

      selectCourse(index) {
        
      },
      
      async back() {
        if (await this.canBack()) {
          this.setStep(this.step - 1);
        }
      },

      async continues() {
        if (await this.canContinue()) {
          this.setStep(this.step + 1);
        }
      },

      cancel() { 
        if (process.env.VUE_APP_SENTRY_ENV == "production") {
          this.$analytics.logEvent("web_golf_courses_cancel");
        }
        this.$router.push('/courses');
      },

      ...mapMutations('CourseSetup', ['setStep', 'setShowNewUserPage', 'resetStore', 'setLoading', 'setSetupData']),
    },

    mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Golf Courses Setup");
        this.$analytics.logEvent("web_golf_courses_setup");
      }

      this.courseId = this.$router.currentRoute.params.course_id;

      this.setStep(1);
      this.setShowNewUserPage(false);
      this.loadData();
    },

    beforeDestroy() {
      this.resetStore();
    },
  };

</script>
